export const environment = {
  production: false,
  baseURL: "https://shopapi.veeranet.ir/api/v1/",
  //editorApiKey: "81l9kmrpoo0pilz407x4kqraxt4ibjebc29bg87ziimii2hn",
  editorApiKey: "9y3vlaarf0ipbf2xfkx45e9tpsvyk6amw0qm8l0khsortwer"

};
